import { useEffect, useState } from 'react';
// node.js library that concatenates classes (strings)
// javascipt plugin for creating charts
import Chart from 'chart.js';
// react plugin used to create charts
// reactstrap components
import {
  Container,
  Row,
  Col,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
} from 'reactstrap';

//Ant components
import Tabs from 'antd/lib/tabs';
import 'antd/lib/tabs/style/index.css';

// core components
import { chartOptions, parseOptions } from '../../variables/charts.js';
import classnames from 'classnames';
//import { map, get, find, toNumber } from 'lodash-es';
//import { differenceInSeconds } from 'date-fns';

import icon from 'leaflet/dist/images/marker-icon.png';
import Header from '../../components/Headers/Header.js';

import JoulepointMap from '../../components/map/JoulepointMap';
import ChargersMap from '../../components/map/ChargersMap';

import CustomerSingleMetricsheader from '../../components/Headers/CustomerSingleMetricsHeader';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import L from 'leaflet';
import AmountTimeHostChart from 'components/chart/EarningHost.js'; //revenue
import SessionTimeHostChart from '../../components/chart/SessionHost'; //sales number
import KwhTimeCustomerChart from 'components/chart/KwhCustomer.js'; // kwh purchased
import AmountTimeCustomerChart from 'components/chart/SpendingCustomer.js'; //amount spend
import KwhTimeHostChart from 'components/chart/KwhHost';
import DurationTimeCustomerChart from 'components/chart/DurationCustomer';
import { createUseStyles } from 'react-jss';
import { generateGranularityBasedDateRange } from '../../utils/misc';
import { useWhoAmI } from 'utils/queries/profileQueries';
import moment from 'moment';
import { ChargingSessionsGridCustomer } from 'components/Reusable/ChargingSessionsGridCustomer';
import ChargerwiseAnalytics from 'components/chart/ChargerwiseAnalytics.js';
import ChargingSessionsTable from 'components/Reusable/ChargingSessionsTable/index.js';
import { useHostChargersForAllPeriods } from 'utils/queries/hostQueries.js';
import InvoiceModal from 'components/Modals/InvoiceModal.js';
import CorporateAdminDashboard from 'views/Corporates/CorporateAdminDashboard.js';
// import { ChargingSessionsGridCustomer } from 'components/Reusable/ChargingSessionsGridCustomer';
let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
});

L.Marker.prototype.options.icon = DefaultIcon;

const { TabPane: AntTabPane } = Tabs;

const useStyles = createUseStyles({
  showMapStickyButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '-39px',
    position: 'fixed' /* Safari */,
    top: 175,
    zIndex: 1000000001,
    height: '50px',
    width: '34px',
    backgroundColor: 'white',
    borderTopRightRadius: '7px',
    borderBottomRightRadius: '7px',
    '&:hover': {
      /* width: '100px',
      transitionDuration: '0.3s', */
      backgroundColor: '#ededed',
      cursor: 'pointer',
      color: 'black',
    },
    fontSize: '15px',
    fontWeight: 'bold',
    color: 'black',
    borderRight: '1px solid #dfdfe1',
    borderTop: '1px solid #dfdfe1',
    borderBottom: '1px solid #dfdfe1',
  },
  minimizeMapButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '-39px',
    position: 'absolute' /* Safari */,
    top: -30,
    right: 15,
    zIndex: 1000000001,
    height: '30px',
    width: '50px',
    backgroundColor: 'white',
    borderTopRightRadius: '7px',
    borderTopLeftRadius: '7px',
    '&:hover': {
      backgroundColor: '#ededed',
      cursor: 'pointer',
      color: 'black',
    },
    fontSize: '15px',
    fontWeight: 'bold',
    color: 'black',
    borderRight: '1px solid #dfdfe1',
    borderLeft: '1px solid #dfdfe1',
    borderTop: '1px solid #dfdfe1',
  },
  antTabs: {
    marginTop: '100px',
    width: '100%',
    '& .ant-tabs-tab': {
      margin: '0px',
      paddingLeft: '13px',
      paddingTop: '10px!important',
      paddingBottom: '10px!important',
      paddingRight: '13px',
      border: '1px solid #e1e1e4',
      borderTopLeftRadius: (props) =>
        props.userType === 'customer' ? '0px' : '5px',
      borderTopRightRadius: (props) =>
        props.userType === 'host' ? '0px' : '5px',
    },
    '& .ant-tabs-tab-active': {
      backgroundColor: '#2675b8',
      color: 'white!important',
      fontColor: 'white!important',

      borderTopLeftRadius: (props) =>
        props.userType === 'customer' ? '5px' : '0px',
      borderTopRightRadius: (props) =>
        props.userType === 'host' ? '5px' : '0px',
    },
    '& .ant-tabs-tab-active .ant-tabs-tab-btn': {
      color: 'white!important',
    },
    '& .ant-tabs-nav-list': {
      marginLeft: '41px',
    },
  },
  transactionId: {
    color: '#438afe',
    '&:hover': {
      cursor: 'pointer',
    },
    fontWeight: 'bold',
  },
  pageNum: {
    fontWeight: 'bold',
    paddingRight: '10px',
    paddingLeft: '10px',
    paddingTop: '6px',
  },
  activePageNum: {
    backgroundColor: '#2675b8',
    color: 'white',
    borderRadius: '5px',
  },
  pagination: {
    display: 'flex',
    listStyle: 'none',
    paddingLeft: '0px',
    justifyContent: 'flex-end',
  },
});

const Dashboard = (props) => {
  const { data: accountInfo } = useWhoAmI();
  const [customerGranDates, setCustomerGranDates] = useState({
    startDate: '',
    endDate: '',
  });
  const [hostGranDates, setHostGranDates] = useState({
    startDate: '',
    endDate: '',
  });

  const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
  const toggleInvoiceModal = () => setOpenInvoiceModal(!openInvoiceModal);

  if (window.Chart) {
    parseOptions(Chart, chartOptions());
  }

  const { data: chargersDetails = [] } = useHostChargersForAllPeriods();

  //userType Tabs
  const [userType, setuserType] = useState('customer');

  const classes = useStyles({ ...props, userType });

  /* Revenue and sales chart states */
  const [activeTab, setActiveTab] = useState('1');
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const [granularityTotalRevenue, setGranularityTotalRevenue] =
    useState('last_10_days');
  const [granularitySalesNumber, setGranularitySalesNumber] =
    useState('last_10_days');
  const [granularityKWHSold, setGranularityKWHSold] = useState('last_10_days');

  /* Customer side analytis states */
  const [activeTabC, setActiveTabC] = useState('1');
  const toggleC = (tab) => {
    if (activeTabC !== tab) setActiveTabC(tab);
  };
  const [granularityTotalKWHPurchased, setGranularityTotalKWHPurchased] =
    useState('last_10_days');
  const [granularityTotalAmountSpent, setGranularityTotalAmountSpent] =
    useState('last_10_days');
  const [granularityTimeDuration, setGranularityTimeDuration] =
    useState('last_10_days');

  const initialSelectedIndexData = {
    energySoldSelectedIndex: -1,
    netRevenueSelectedIndex: -1,
    chargingSessionsSelectedIndex: -1,
    chargerAnalyticsSelectedIndex: -1,
  };

  const [selectedIndexData, setSelectedIndexData] = useState(
    initialSelectedIndexData,
  );

  useEffect(() => {
    const hostGranularities = [
      granularityKWHSold,
      granularityTotalRevenue,
      granularitySalesNumber,
    ];
    if (activeTab > 1) {
      const dates = generateGranularityBasedDateRange(
        hostGranularities[activeTab - 2],
      );

      setHostGranDates(dates);
      const param = {
        startDate: moment(dates.startDate, 'DD/MM/YYYY').format('DD-MM-YYYY'),
        endDate: moment(dates.endDate, 'DD/MM/YYYY').format('DD-MM-YYYY'),
        chargers: [],
        states: [],
      };
      setSearchParams(param);
      setSelectedIndexData({
        energySoldSelectedIndex: -1,
        netRevenueSelectedIndex: -1,
        chargingSessionsSelectedIndex: -1,
        chargerAnalyticsSelectedIndex: -1,
      });
    }
  }, [
    activeTab,
    granularityKWHSold,
    granularityTotalRevenue,
    granularitySalesNumber,
  ]);
  useEffect(() => {
    const customerGranularities = [
      granularityTotalKWHPurchased,
      granularityTotalAmountSpent,
      granularityTimeDuration,
    ];
    if (activeTabC > 1) {
      setCustomerGranDates(
        generateGranularityBasedDateRange(
          customerGranularities[activeTabC - 2],
        ),
      );
    }
  }, [
    activeTabC,
    granularityTotalKWHPurchased,
    granularityTotalAmountSpent,
    granularityTimeDuration,
  ]);

  const [searchParams, setSearchParams] = useState(null);

  const getStartEndDateOfBar = (
    granularity,
    label,
    chartName,
    barIndex = -1,
  ) => {
    if (!label) return;
    let startDate = '';
    let endDate = '';
    if (granularity === 'last_10_days') {
      startDate = label;
      endDate = label;
    } else if (granularity === 'monthly') {
      startDate = moment(`01 ${label}`).startOf('month').format('DD-MM-YYYY');
      endDate = moment(`01 ${label}`).endOf('month').format('DD-MM-YYYY');
    } else if (granularity === 'yearly') {
      startDate = moment(`01-01-${label}`).startOf('year').format('DD-MM-YYYY');
      endDate =
        moment().format('YYYY') === label
          ? moment().format('DD-MM-YYYY')
          : moment(`01-01-${label}`).endOf('year').format('DD-MM-YYYY');
    }
    setCustomerGranDates({ startDate, endDate });
    setHostGranDates({ startDate, endDate });
    const params = {
      chargers: [],
      startDate: moment(startDate, 'DD-MM-YYYY').format('DD-MM-YYYY'),
      endDate: moment(endDate, 'DD-MM-YYYY').format('DD-MM-YYYY'),
      states: [],
    };
    setSearchParams(params);
    const selIndexData = {
      energySoldSelectedIndex: chartName === 'energySold' ? barIndex : -1,
      netRevenueSelectedIndex: chartName === 'netRevenue' ? barIndex : -1,
      chargingSessionsSelectedIndex:
        chartName === 'chargingSession' ? barIndex : -1,
      chargerAnalyticsSelectedIndex:
        chartName === 'chargerAnalytics' ? barIndex : -1,
    };
    setSelectedIndexData(selIndexData);
  };

  const getChargerBarClickHandler = (cpid, barIndex) => {
    const params = { ...searchParams };
    params.chargers = [cpid];
    setSearchParams(params);
    const selIndexData = {
      ...selectedIndexData,
      chargerAnalyticsSelectedIndex: barIndex > -1 ? barIndex : -1,
    };
    setSelectedIndexData(selIndexData);
  };

  return (
    <>
      <Tabs
        defaultActiveKey="1"
        className={classes.antTabs}
        onChange={(key) => setuserType(key)}
      >
        <AntTabPane tab="My Dashboard" key="customer">
          <CustomerSingleMetricsheader paddingTop="15px" paddingBottom="15px" />

          <Container fluid>
            <Row style={{ marginTop: '20px' }}>
              <Col className="order-xl-1" xl="12">
                <div>
                  <Nav tabs centered={'true'}>
                    <NavItem style={{ cursor: 'pointer' }}>
                      <NavLink
                        className={classnames({
                          active: activeTabC === '1',
                        })}
                        style={{
                          padding: '10px',
                          backgroundColor:
                            activeTabC === '1' ? '#2675b8' : 'transparent',
                          color: activeTabC === '1' ? 'white' : 'black',
                          border:
                            activeTabC === '1' ? 'none' : '1px solid #e4e8ec',
                          borderTopRightRadius: '0px',
                          paddingLeft: '20px',
                          paddingRight: '20px',
                        }}
                        onClick={() => {
                          toggleC('1');
                        }}
                      >
                        Charging Sessions (Map view)
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ cursor: 'pointer' }}>
                      <NavLink
                        className={classnames({
                          active: activeTabC === '2',
                        })}
                        style={{
                          padding: '10px',
                          backgroundColor:
                            activeTabC === '2' ? '#2675b8' : 'transparent',
                          color: activeTabC === '2' ? 'white' : 'black',
                          border:
                            activeTabC === '2' ? 'none' : '1px solid #e4e8ec',
                          borderTopRightRadius: '0px',
                          borderTopLeftRadius: '0px',
                          paddingLeft: '20px',
                          paddingRight: '20px',
                        }}
                        onClick={() => {
                          toggleC('2');
                        }}
                      >
                        Energy Purchased
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ cursor: 'pointer' }}>
                      <NavLink
                        className={classnames({ active: activeTabC === '3' })}
                        onClick={() => {
                          toggleC('3');
                        }}
                        style={{
                          padding: '10px',
                          backgroundColor:
                            activeTabC === '3' ? '#2675b8' : 'transparent',
                          color: activeTabC === '3' ? 'white' : 'black',
                          border:
                            activeTabC === '3' ? 'none' : '1px solid #e4e8ec',
                          borderTopLeftRadius: '0px',
                          borderTopRightRadius: '0px',
                          paddingLeft: '20px',
                          paddingRight: '20px',
                        }}
                      >
                        Amount Spent
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ cursor: 'pointer' }}>
                      <NavLink
                        className={classnames({ active: activeTabC === '4' })}
                        onClick={() => {
                          toggleC('4');
                        }}
                        style={{
                          padding: '10px',
                          backgroundColor:
                            activeTabC === '4' ? '#2675b8' : 'transparent',
                          color: activeTabC === '4' ? 'white' : 'black',
                          border:
                            activeTabC === '4' ? 'none' : '1px solid #e4e8ec',
                          borderTopLeftRadius: '0px',
                          paddingLeft: '20px',
                          paddingRight: '20px',
                        }}
                      >
                        Charging Duration
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <TabContent
                    activeTab={activeTabC}
                    style={{
                      padding: activeTabC === '1' ? '0px' : '10px',
                      backgroundColor: 'white',
                      borderRadius: '0px 0px 7px 7px',
                      boxShadow: '0 0 2rem 0 rgb(136 152 170 / 15%)',
                      height: '550px',
                    }}
                  >
                    <TabPane tabId="1">
                      <JoulepointMap
                        records={props.sessions}
                        mapType="customer_charging_sessions"
                      />
                    </TabPane>
                    <TabPane tabId="2">
                      <Row>
                        <Col
                          sm="12"
                          md="12"
                          lg="12"
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                          className="mt-3"
                        >
                          <div className="px-3 mt--1">
                            <h2 className="text mb-0">
                              Energy Purchased{' '}
                              <span
                                style={{
                                  fontSize: '12px',
                                  fontWeight: 'normal',
                                }}
                              >
                                (Customer)
                              </span>
                            </h2>
                            <p
                              className="text mb-0"
                              style={{ fontWeight: 500 }}
                            >
                              {
                                generateGranularityBasedDateRange(
                                  granularityTotalKWHPurchased,
                                ).startDate
                              }{' '}
                              -{' '}
                              {
                                generateGranularityBasedDateRange(
                                  granularityTotalKWHPurchased,
                                ).endDate
                              }
                            </p>
                          </div>
                          <div className="px-3">
                            <Nav className="justify-content-end" pills>
                              <NavItem>
                                <NavLink
                                  className={classnames('py-2 px-3', {
                                    active:
                                      granularityTotalKWHPurchased === 'yearly',
                                  })}
                                  style={{
                                    cursor: 'pointer',
                                    border:
                                      granularityTotalKWHPurchased === 'yearly'
                                        ? '1px solid transparent'
                                        : '1px solid #2675b8',
                                    color:
                                      granularityTotalKWHPurchased === 'yearly'
                                        ? 'white'
                                        : '#2675b8',
                                    backgroundColor:
                                      granularityTotalKWHPurchased === 'yearly'
                                        ? '#2675b8'
                                        : 'white',
                                  }}
                                  preventDefault={true}
                                  onClick={(e) => {
                                    setGranularityTotalKWHPurchased('yearly');
                                  }}
                                >
                                  <span
                                    className="d-none d-md-block"
                                    style={{ cursor: 'pointer' }}
                                  >
                                    Year
                                  </span>
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <NavLink
                                  className={classnames('py-2 px-3', {
                                    active:
                                      granularityTotalKWHPurchased ===
                                      'monthly',
                                  })}
                                  style={{
                                    cursor: 'pointer',
                                    border:
                                      granularityTotalKWHPurchased === 'monthly'
                                        ? '1px solid transparent'
                                        : '1px solid #2675b8',
                                    color:
                                      granularityTotalKWHPurchased === 'monthly'
                                        ? 'white'
                                        : '#2675b8',
                                    backgroundColor:
                                      granularityTotalKWHPurchased === 'monthly'
                                        ? '#2675b8'
                                        : 'white',
                                  }}
                                  preventDefault={true}
                                  onClick={(e) => {
                                    setGranularityTotalKWHPurchased('monthly');
                                  }}
                                >
                                  <span
                                    className="d-none d-md-block"
                                    style={{ cursor: 'pointer' }}
                                  >
                                    Monthly
                                  </span>
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <NavLink
                                  className={classnames('py-2 px-3', {
                                    active:
                                      granularityTotalKWHPurchased ===
                                      'last_10_days',
                                  })}
                                  style={{
                                    cursor: 'pointer',
                                    border:
                                      granularityTotalKWHPurchased ===
                                      'last_10_days'
                                        ? '1px solid transparent'
                                        : '1px solid #2675b8',
                                    color:
                                      granularityTotalKWHPurchased ===
                                      'last_10_days'
                                        ? 'white'
                                        : '#2675b8',
                                    backgroundColor:
                                      granularityTotalKWHPurchased ===
                                      'last_10_days'
                                        ? '#2675b8'
                                        : 'white',
                                  }}
                                  data-toggle="tab"
                                  preventDefault={true}
                                  onClick={(e) => {
                                    setGranularityTotalKWHPurchased(
                                      'last_10_days',
                                    );
                                  }}
                                >
                                  <span
                                    className="d-none d-md-block"
                                    style={{ cursor: 'pointer' }}
                                  >
                                    Last 10 days
                                  </span>
                                </NavLink>
                              </NavItem>
                            </Nav>
                          </div>
                        </Col>
                        <Col sm="12" md="12" lg="12">
                          <div
                            className="chart mt-4 px-3"
                            style={{ paddingBottom: '20px' }}
                          >
                            <KwhTimeCustomerChart
                              granularity={granularityTotalKWHPurchased}
                              handleBarClick={getStartEndDateOfBar}
                            />
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="3">
                      <Row>
                        <Col
                          sm="12"
                          md="12"
                          lg="12"
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                          className="mt-3"
                        >
                          <div className="px-3 mt--1">
                            <h2 className="text mb-0">
                              Amount Spent{' '}
                              <span
                                style={{
                                  fontSize: '12px',
                                  fontWeight: 'normal',
                                }}
                              >
                                (Customer)
                              </span>
                            </h2>
                            <p
                              className="text mb-0"
                              style={{ fontWeight: 500 }}
                            >
                              {
                                generateGranularityBasedDateRange(
                                  granularityTotalAmountSpent,
                                ).startDate
                              }{' '}
                              -{' '}
                              {
                                generateGranularityBasedDateRange(
                                  granularityTotalAmountSpent,
                                ).endDate
                              }
                            </p>
                          </div>
                          <div className="px-3">
                            <Nav className="justify-content-end" pills>
                              <NavItem>
                                <NavLink
                                  className={classnames('py-2 px-3', {
                                    active:
                                      granularityTotalAmountSpent === 'yearly',
                                  })}
                                  style={{
                                    cursor: 'pointer',
                                    border:
                                      granularityTotalAmountSpent === 'yearly'
                                        ? '1px solid transparent'
                                        : '1px solid #2675b8',
                                    color:
                                      granularityTotalAmountSpent === 'yearly'
                                        ? 'white'
                                        : '#2675b8',
                                    backgroundColor:
                                      granularityTotalAmountSpent === 'yearly'
                                        ? '#2675b8'
                                        : 'white',
                                  }}
                                  preventDefault={true}
                                  onClick={(e) => {
                                    setGranularityTotalAmountSpent('yearly');
                                  }}
                                >
                                  <span
                                    className="d-none d-md-block"
                                    style={{ cursor: 'pointer' }}
                                  >
                                    Year
                                  </span>
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <NavLink
                                  className={classnames('py-2 px-3', {
                                    active:
                                      granularityTotalAmountSpent === 'monthly',
                                  })}
                                  style={{
                                    cursor: 'pointer',
                                    border:
                                      granularityTotalAmountSpent === 'monthly'
                                        ? '1px solid transparent'
                                        : '1px solid #2675b8',
                                    color:
                                      granularityTotalAmountSpent === 'monthly'
                                        ? 'white'
                                        : '#2675b8',
                                    backgroundColor:
                                      granularityTotalAmountSpent === 'monthly'
                                        ? '#2675b8'
                                        : 'white',
                                  }}
                                  preventDefault={true}
                                  onClick={(e) => {
                                    setGranularityTotalAmountSpent('monthly');
                                  }}
                                >
                                  <span
                                    className="d-none d-md-block"
                                    style={{ cursor: 'pointer' }}
                                  >
                                    Monthly
                                  </span>
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <NavLink
                                  className={classnames('py-2 px-3', {
                                    active:
                                      granularityTotalAmountSpent ===
                                      'last_10_days',
                                  })}
                                  style={{
                                    cursor: 'pointer',
                                    border:
                                      granularityTotalAmountSpent ===
                                      'last_10_days'
                                        ? '1px solid transparent'
                                        : '1px solid #2675b8',
                                    color:
                                      granularityTotalAmountSpent ===
                                      'last_10_days'
                                        ? 'white'
                                        : '#2675b8',
                                    backgroundColor:
                                      granularityTotalAmountSpent ===
                                      'last_10_days'
                                        ? '#2675b8'
                                        : 'white',
                                  }}
                                  data-toggle="tab"
                                  preventDefault={true}
                                  onClick={(e) => {
                                    setGranularityTotalAmountSpent(
                                      'last_10_days',
                                    );
                                  }}
                                >
                                  <span
                                    className="d-none d-md-block"
                                    style={{ cursor: 'pointer' }}
                                  >
                                    Last 10 days
                                  </span>
                                </NavLink>
                              </NavItem>
                            </Nav>
                          </div>
                        </Col>
                        <Col sm="12" md="12" lg="12">
                          <div
                            className="chart mt-4 px-3"
                            style={{ paddingBottom: '20px' }}
                          >
                            <AmountTimeCustomerChart
                              granularity={granularityTotalAmountSpent}
                              handleBarClick={getStartEndDateOfBar}
                            />
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="4">
                      <Row>
                        <Col
                          sm="12"
                          md="12"
                          lg="12"
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                          className="mt-3"
                        >
                          <div className="px-3 mt--1">
                            <h2 className="text mb-0">
                              Charging Duration{' '}
                              <span
                                style={{
                                  fontSize: '12px',
                                  fontWeight: 'normal',
                                }}
                              >
                                (Customer)
                              </span>
                            </h2>
                            <p
                              className="text mb-0"
                              style={{ fontWeight: 500 }}
                            >
                              {
                                generateGranularityBasedDateRange(
                                  granularityTimeDuration,
                                ).startDate
                              }{' '}
                              -{' '}
                              {
                                generateGranularityBasedDateRange(
                                  granularityTimeDuration,
                                ).endDate
                              }
                            </p>
                          </div>

                          <div className="px-3">
                            <Nav className="justify-content-end" pills>
                              <NavItem>
                                <NavLink
                                  className={classnames('py-2 px-3', {
                                    active:
                                      granularityTimeDuration === 'yearly',
                                  })}
                                  style={{
                                    cursor: 'pointer',
                                    border:
                                      granularityTimeDuration === 'yearly'
                                        ? '1px solid transparent'
                                        : '1px solid #2675b8',
                                    color:
                                      granularityTimeDuration === 'yearly'
                                        ? 'white'
                                        : '#2675b8',
                                    backgroundColor:
                                      granularityTimeDuration === 'yearly'
                                        ? '#2675b8'
                                        : 'white',
                                  }}
                                  preventDefault={true}
                                  onClick={(e) => {
                                    setGranularityTimeDuration('yearly');
                                  }}
                                >
                                  <span
                                    className="d-none d-md-block"
                                    style={{ cursor: 'pointer' }}
                                  >
                                    Year
                                  </span>
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <NavLink
                                  className={classnames('py-2 px-3', {
                                    active:
                                      granularityTimeDuration === 'monthly',
                                  })}
                                  style={{
                                    cursor: 'pointer',
                                    border:
                                      granularityTimeDuration === 'monthly'
                                        ? '1px solid transparent'
                                        : '1px solid #2675b8',
                                    color:
                                      granularityTimeDuration === 'monthly'
                                        ? 'white'
                                        : '#2675b8',
                                    backgroundColor:
                                      granularityTimeDuration === 'monthly'
                                        ? '#2675b8'
                                        : 'white',
                                  }}
                                  preventDefault={true}
                                  onClick={(e) => {
                                    setGranularityTimeDuration('monthly');
                                  }}
                                >
                                  <span
                                    className="d-none d-md-block"
                                    style={{ cursor: 'pointer' }}
                                  >
                                    Monthly
                                  </span>
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <NavLink
                                  className={classnames('py-2 px-3', {
                                    active:
                                      granularityTimeDuration ===
                                      'last_10_days',
                                  })}
                                  style={{
                                    cursor: 'pointer',
                                    border:
                                      granularityTimeDuration === 'last_10_days'
                                        ? '1px solid transparent'
                                        : '1px solid #2675b8',
                                    color:
                                      granularityTimeDuration === 'last_10_days'
                                        ? 'white'
                                        : '#2675b8',
                                    backgroundColor:
                                      granularityTimeDuration === 'last_10_days'
                                        ? '#2675b8'
                                        : 'white',
                                  }}
                                  data-toggle="tab"
                                  preventDefault={true}
                                  onClick={(e) => {
                                    setGranularityTimeDuration('last_10_days');
                                  }}
                                >
                                  <span
                                    className="d-none d-md-block"
                                    style={{ cursor: 'pointer' }}
                                  >
                                    Last 10 days
                                  </span>
                                </NavLink>
                              </NavItem>
                            </Nav>
                          </div>
                        </Col>
                        <Col>
                          <div
                            className="chart mt-4 px-3"
                            style={{ paddingBottom: '20px' }}
                          >
                            <DurationTimeCustomerChart
                              granularity={granularityTimeDuration}
                              handleBarClick={getStartEndDateOfBar}
                            />
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                </div>
              </Col>
            </Row>

            {activeTabC > 1 && (
              <ChargingSessionsGridCustomer
                startDate={customerGranDates.startDate}
                endDate={customerGranDates.endDate}
              />
            )}
          </Container>
        </AntTabPane>
        {accountInfo?.user?.IS_HOST && (
          <AntTabPane tab="Host Dashboard" key="host">
            <Header
              paddingTop="5px"
              paddingBottom="15px"
              displayHostLabel={true}
              marginTop="-1px"
            />

            <Container fluid>
              <Row style={{ marginTop: '5px' }}>
                <Col className="order-xl-1" xl="12">
                  <div>
                    <Nav tabs>
                      <NavItem style={{ cursor: 'pointer' }}>
                        <NavLink
                          className={classnames({
                            active: activeTab === '1',
                          })}
                          style={{
                            padding: '10px',
                            backgroundColor:
                              activeTab === '1' ? '#2675b8' : 'transparent',
                            color: activeTab === '1' ? 'white' : 'black',
                            border:
                              activeTab === '1' ? 'none' : '1px solid #e4e8ec',
                            borderTopRightRadius: '0px',
                            paddingLeft: '20px',
                            paddingRight: '20px',
                          }}
                          onClick={() => {
                            toggle('1');
                          }}
                        >
                          Chargers (Map view)
                        </NavLink>
                      </NavItem>
                      <NavItem style={{ cursor: 'pointer' }}>
                        <NavLink
                          className={classnames({
                            active: activeTab === '2',
                          })}
                          style={{
                            padding: '10px',
                            backgroundColor:
                              activeTab === '2' ? '#2675b8' : 'transparent',
                            color: activeTab === '2' ? 'white' : 'black',
                            border:
                              activeTab === '2' ? 'none' : '1px solid #e4e8ec',
                            borderTopRightRadius: '0px',
                            borderTopLeftRadius: '0px',
                            paddingLeft: '20px',
                            paddingRight: '20px',
                          }}
                          onClick={() => {
                            toggle('2');
                          }}
                        >
                          Energy Sold
                        </NavLink>
                      </NavItem>
                      <NavItem style={{ cursor: 'pointer' }}>
                        <NavLink
                          className={classnames({
                            active: activeTab === '3',
                          })}
                          style={{
                            padding: '10px',
                            backgroundColor:
                              activeTab === '3' ? '#2675b8' : 'transparent',
                            color: activeTab === '3' ? 'white' : 'black',
                            border:
                              activeTab === '3' ? 'none' : '1px solid #e4e8ec',
                            borderTopRightRadius: '0px',
                            borderTopLeftRadius: '0px',
                            paddingLeft: '20px',
                            paddingRight: '20px',
                          }}
                          onClick={() => {
                            toggle('3');
                          }}
                        >
                          Net Revenue
                        </NavLink>
                      </NavItem>
                      <NavItem style={{ cursor: 'pointer' }}>
                        <NavLink
                          className={classnames({ active: activeTab === '4' })}
                          onClick={() => {
                            toggle('4');
                          }}
                          style={{
                            padding: '10px',
                            backgroundColor:
                              activeTab === '4' ? '#2675b8' : 'transparent',
                            color: activeTab === '4' ? 'white' : 'black',
                            border:
                              activeTab === '4' ? 'none' : '1px solid #e4e8ec',
                            borderTopLeftRadius: '0px',
                            paddingLeft: '20px',
                            paddingRight: '20px',
                          }}
                        >
                          Charging Sessions
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent
                      activeTab={activeTab}
                      style={{
                        padding: activeTab === '1' ? '0px' : '10px',
                        backgroundColor: 'white',
                        borderRadius: '0px 0px 7px 7px',
                        boxShadow: '0 0 2rem 0 rgb(136 152 170 / 15%)',
                        height: '550px',
                      }}
                    >
                      <TabPane tabId="1">
                        <ChargersMap records={props.chargers} />
                      </TabPane>
                      <TabPane tabId="2">
                        <Row>
                          <Col
                            sm="12"
                            md="12"
                            lg="12"
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                            className="mt-3"
                          >
                            <div className="px-3 mt--1">
                              <h2 className="text mb-0">
                                Energy Sold{' '}
                                <span
                                  style={{
                                    fontSize: '12px',
                                    fontWeight: 'normal',
                                  }}
                                >
                                  (Host)
                                </span>
                              </h2>
                              <p
                                className="text mb-0"
                                style={{ fontWeight: 500 }}
                              >
                                {
                                  generateGranularityBasedDateRange(
                                    granularityKWHSold,
                                  ).startDate
                                }{' '}
                                -{' '}
                                {
                                  generateGranularityBasedDateRange(
                                    granularityKWHSold,
                                  ).endDate
                                }
                              </p>
                            </div>
                            <div className="px-3">
                              <Nav className="justify-content-end" pills>
                                <NavItem>
                                  <NavLink
                                    className={classnames('py-2 px-3', {
                                      active: granularityKWHSold === 'yearly',
                                    })}
                                    style={{
                                      cursor: 'pointer',
                                      border:
                                        granularityKWHSold === 'yearly'
                                          ? '1px solid transparent'
                                          : '1px solid #2675b8',
                                      color:
                                        granularityKWHSold === 'yearly'
                                          ? 'white'
                                          : '#2675b8',
                                      backgroundColor:
                                        granularityKWHSold === 'yearly'
                                          ? '#2675b8'
                                          : 'white',
                                    }}
                                    preventDefault={true}
                                    onClick={(e) => {
                                      setGranularityKWHSold('yearly');
                                    }}
                                  >
                                    <span
                                      className="d-none d-md-block"
                                      style={{ cursor: 'pointer' }}
                                    >
                                      Year
                                    </span>
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    className={classnames('py-2 px-3', {
                                      active: granularityKWHSold === 'monthly',
                                    })}
                                    style={{
                                      cursor: 'pointer',
                                      border:
                                        granularityKWHSold === 'monthly'
                                          ? '1px solid transparent'
                                          : '1px solid #2675b8',
                                      color:
                                        granularityKWHSold === 'monthly'
                                          ? 'white'
                                          : '#2675b8',
                                      backgroundColor:
                                        granularityKWHSold === 'monthly'
                                          ? '#2675b8'
                                          : 'white',
                                    }}
                                    preventDefault={true}
                                    onClick={(e) => {
                                      setGranularityKWHSold('monthly');
                                    }}
                                  >
                                    <span
                                      className="d-none d-md-block"
                                      style={{ cursor: 'pointer' }}
                                    >
                                      Monthly
                                    </span>
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    className={classnames('py-2 px-3', {
                                      active:
                                        granularityKWHSold === 'last_10_days',
                                    })}
                                    style={{
                                      cursor: 'pointer',
                                      border:
                                        granularityKWHSold === 'last_10_days'
                                          ? '1px solid transparent'
                                          : '1px solid #2675b8',
                                      color:
                                        granularityKWHSold === 'last_10_days'
                                          ? 'white'
                                          : '#2675b8',
                                      backgroundColor:
                                        granularityKWHSold === 'last_10_days'
                                          ? '#2675b8'
                                          : 'white',
                                    }}
                                    data-toggle="tab"
                                    preventDefault={true}
                                    onClick={(e) => {
                                      setGranularityKWHSold('last_10_days');
                                    }}
                                  >
                                    <span
                                      className="d-none d-md-block"
                                      style={{ cursor: 'pointer' }}
                                    >
                                      Last 10 days
                                    </span>
                                  </NavLink>
                                </NavItem>
                              </Nav>
                            </div>
                          </Col>
                          <Col>
                            <div
                              className="chart mt-4 px-3"
                              style={{ paddingBottom: '20px' }}
                            >
                              <KwhTimeHostChart
                                granularity={granularityKWHSold}
                                handleBarClick={getStartEndDateOfBar}
                                selectedBarIndex={
                                  selectedIndexData.energySoldSelectedIndex
                                }
                              />
                            </div>
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="3">
                        <Row>
                          <Col
                            sm="12"
                            md="12"
                            lg="12"
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                            className="mt-3"
                          >
                            <div className="px-3 mt--1">
                              <h2 className="text mb-0">
                                Net Revenue{' '}
                                <span
                                  style={{
                                    fontSize: '12px',
                                    fontWeight: 'normal',
                                  }}
                                >
                                  (Host)
                                </span>
                              </h2>
                              <p
                                className="text mb-0"
                                style={{ fontWeight: 500 }}
                              >
                                {
                                  generateGranularityBasedDateRange(
                                    granularityTotalRevenue,
                                  ).startDate
                                }{' '}
                                -{' '}
                                {
                                  generateGranularityBasedDateRange(
                                    granularityTotalRevenue,
                                  ).endDate
                                }
                              </p>
                            </div>
                            <div className="px-3">
                              <Nav className="justify-content-end" pills>
                                <NavItem>
                                  <NavLink
                                    className={classnames('py-2 px-3', {
                                      active:
                                        granularityTotalRevenue === 'yearly',
                                    })}
                                    style={{
                                      cursor: 'pointer',
                                      border:
                                        granularityTotalRevenue === 'yearly'
                                          ? '1px solid transparent'
                                          : '1px solid #2675b8',
                                      color:
                                        granularityTotalRevenue === 'yearly'
                                          ? 'white'
                                          : '#2675b8',
                                      backgroundColor:
                                        granularityTotalRevenue === 'yearly'
                                          ? '#2675b8'
                                          : 'white',
                                    }}
                                    preventDefault={true}
                                    onClick={(e) => {
                                      setGranularityTotalRevenue('yearly');
                                    }}
                                  >
                                    <span
                                      className="d-none d-md-block"
                                      style={{ cursor: 'pointer' }}
                                    >
                                      Year
                                    </span>
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    className={classnames('py-2 px-3', {
                                      active:
                                        granularityTotalRevenue === 'monthly',
                                    })}
                                    style={{
                                      cursor: 'pointer',
                                      border:
                                        granularityTotalRevenue === 'monthly'
                                          ? '1px solid transparent'
                                          : '1px solid #2675b8',
                                      color:
                                        granularityTotalRevenue === 'monthly'
                                          ? 'white'
                                          : '#2675b8',
                                      backgroundColor:
                                        granularityTotalRevenue === 'monthly'
                                          ? '#2675b8'
                                          : 'white',
                                    }}
                                    preventDefault={true}
                                    onClick={(e) => {
                                      setGranularityTotalRevenue('monthly');
                                    }}
                                  >
                                    <span
                                      className="d-none d-md-block"
                                      style={{ cursor: 'pointer' }}
                                    >
                                      Monthly
                                    </span>
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    className={classnames('py-2 px-3', {
                                      active:
                                        granularityTotalRevenue ===
                                        'last_10_days',
                                    })}
                                    style={{
                                      cursor: 'pointer',
                                      border:
                                        granularityTotalRevenue ===
                                        'last_10_days'
                                          ? '1px solid transparent'
                                          : '1px solid #2675b8',
                                      color:
                                        granularityTotalRevenue ===
                                        'last_10_days'
                                          ? 'white'
                                          : '#2675b8',
                                      backgroundColor:
                                        granularityTotalRevenue ===
                                        'last_10_days'
                                          ? '#2675b8'
                                          : 'white',
                                    }}
                                    data-toggle="tab"
                                    preventDefault={true}
                                    onClick={(e) => {
                                      setGranularityTotalRevenue(
                                        'last_10_days',
                                      );
                                    }}
                                  >
                                    <span
                                      className="d-none d-md-block"
                                      style={{ cursor: 'pointer' }}
                                    >
                                      Last 10 days
                                    </span>
                                  </NavLink>
                                </NavItem>
                              </Nav>
                            </div>
                          </Col>
                          <Col>
                            <div
                              className="chart mt-4 px-3"
                              style={{ paddingBottom: '20px' }}
                            >
                              <AmountTimeHostChart
                                granularity={granularityTotalRevenue}
                                handleBarClick={getStartEndDateOfBar}
                                selectedBarIndex={
                                  selectedIndexData.netRevenueSelectedIndex
                                }
                              />
                            </div>
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="4">
                        <Row>
                          <Col
                            sm="12"
                            md="12"
                            lg="12"
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                            className="mt-3"
                          >
                            <div className="px-3 mt--1">
                              <h2 className="text mb-0">
                                Charging Sessions{' '}
                                <span
                                  style={{
                                    fontSize: '12px',
                                    fontWeight: 'normal',
                                  }}
                                >
                                  (Host)
                                </span>
                              </h2>
                              <p
                                className="text mb-0"
                                style={{ fontWeight: 500 }}
                              >
                                {
                                  generateGranularityBasedDateRange(
                                    granularitySalesNumber,
                                  ).startDate
                                }{' '}
                                -{' '}
                                {
                                  generateGranularityBasedDateRange(
                                    granularitySalesNumber,
                                  ).endDate
                                }
                              </p>
                            </div>

                            <div className="px-3">
                              <Nav className="justify-content-end" pills>
                                <NavItem>
                                  <NavLink
                                    className={classnames('py-2 px-3', {
                                      active:
                                        granularitySalesNumber === 'yearly',
                                    })}
                                    style={{
                                      cursor: 'pointer',
                                      border:
                                        granularitySalesNumber === 'yearly'
                                          ? '1px solid transparent'
                                          : '1px solid #2675b8',
                                      color:
                                        granularitySalesNumber === 'yearly'
                                          ? 'white'
                                          : '#2675b8',
                                      backgroundColor:
                                        granularitySalesNumber === 'yearly'
                                          ? '#2675b8'
                                          : 'white',
                                    }}
                                    preventDefault={true}
                                    onClick={(e) => {
                                      setGranularitySalesNumber('yearly');
                                    }}
                                  >
                                    <span
                                      className="d-none d-md-block"
                                      style={{ cursor: 'pointer' }}
                                    >
                                      Year
                                    </span>
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    className={classnames('py-2 px-3', {
                                      active:
                                        granularitySalesNumber === 'monthly',
                                    })}
                                    style={{
                                      cursor: 'pointer',
                                      border:
                                        granularitySalesNumber === 'monthly'
                                          ? '1px solid transparent'
                                          : '1px solid #2675b8',
                                      color:
                                        granularitySalesNumber === 'monthly'
                                          ? 'white'
                                          : '#2675b8',
                                      backgroundColor:
                                        granularitySalesNumber === 'monthly'
                                          ? '#2675b8'
                                          : 'white',
                                    }}
                                    preventDefault={true}
                                    onClick={(e) => {
                                      setGranularitySalesNumber('monthly');
                                    }}
                                  >
                                    <span
                                      className="d-none d-md-block"
                                      style={{ cursor: 'pointer' }}
                                    >
                                      Monthly
                                    </span>
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    className={classnames('py-2 px-3', {
                                      active:
                                        granularitySalesNumber ===
                                        'last_10_days',
                                    })}
                                    style={{
                                      cursor: 'pointer',
                                      border:
                                        granularitySalesNumber ===
                                        'last_10_days'
                                          ? '1px solid transparent'
                                          : '1px solid #2675b8',
                                      color:
                                        granularitySalesNumber ===
                                        'last_10_days'
                                          ? 'white'
                                          : '#2675b8',
                                      backgroundColor:
                                        granularitySalesNumber ===
                                        'last_10_days'
                                          ? '#2675b8'
                                          : 'white',
                                    }}
                                    data-toggle="tab"
                                    preventDefault={true}
                                    onClick={(e) => {
                                      setGranularitySalesNumber('last_10_days');
                                    }}
                                  >
                                    <span
                                      className="d-none d-md-block"
                                      style={{ cursor: 'pointer' }}
                                    >
                                      Last 10 days
                                    </span>
                                  </NavLink>
                                </NavItem>
                              </Nav>
                            </div>
                          </Col>
                          <Col sm="12" md="12" lg="12">
                            <div
                              className="chart mt-4 px-3"
                              style={{ paddingBottom: '20px' }}
                            >
                              <SessionTimeHostChart
                                granularity={granularitySalesNumber}
                                handleBarClick={getStartEndDateOfBar}
                                selectedBarIndex={
                                  selectedIndexData.chargingSessionsSelectedIndex
                                }
                              />
                            </div>
                          </Col>
                        </Row>
                      </TabPane>
                    </TabContent>
                  </div>
                </Col>
              </Row>

              {/***************************************************************/}

              {activeTab !== '1' && (
                <ChargerwiseAnalytics
                  activeTab={activeTab ? parseInt(activeTab) : -1}
                  startDate={hostGranDates.startDate}
                  endDate={hostGranDates.endDate}
                  handleBarClick={getChargerBarClickHandler}
                  selectedBarIndex={
                    selectedIndexData.chargerAnalyticsSelectedIndex
                  }
                  chargersDetails={chargersDetails}
                ></ChargerwiseAnalytics>
              )}
              {/***************************************************************/}

              {activeTab > 1 && (
                <>
                  <ChargingSessionsTable
                    chargingSessionsParams={searchParams}
                    showDateRange={true}
                    chargersDetails={chargersDetails}
                    setInvoicePopup={setOpenInvoiceModal}
                  />

                  <InvoiceModal
                    modalOpen={openInvoiceModal}
                    toggleModalOpen={toggleInvoiceModal}
                    chargersDetails={chargersDetails}
                    startDate={hostGranDates?.startDate}
                    endDate={hostGranDates?.endDate}
                    chargers={searchParams?.chargers}
                  />
                </>
              )}
            </Container>
          </AntTabPane>
        )}

        {accountInfo?.user?.IS_CORPORATE_ADMIN && (
          <AntTabPane tab="Corporate Admin" key="corporateAdmin">
            <CorporateAdminDashboard
              corporateId={accountInfo?.user?.corporate?.ID || ''}
            />
          </AntTabPane>
        )}
      </Tabs>
    </>
  );
};

export default Dashboard;
